module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/UnitsList/images/tr-background.d42a2e15.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/UnitsList/images/tr-background.png
// module id = 2763
// module chunks = 11